<template>
    <q-modal>
        <div class="layout-padding">
            <div class="modal-close">
                <q-btn color="primary" round dense icon="close" @click="showLogin = false;$router.push('/desporto')"></q-btn>
            </div>

            <div class="q-py-lg">

                <template v-if="!user">
                    <form @submit.prevent="login(slug)"
                          class="gutter-xs q-pa-xs"
                          @keydown="form.onKeydown($event)">

                        <div class="text-center"><img src="../../../img/identity/unitelfutebol-dark.svg" width="100%"/>
                        </div>

                        <!-- Submit Button -->
                        <div class="row justify-center">
                            <v-submit :label="$t('log in')"
                                      :loadingLabel="$t('validating...')"
                                      color="primary"
                                      :form="form">
                            </v-submit>
                        </div>

                    </form>

                    <template slot="actions">
                        <q-btn flat color="highlight" @click="$router.push({ name: 'password.request' })"
                               :label="$T('forgot your password?')"></q-btn>
                    </template>
                </template>

                <div v-else class="q-pa-xl text-center">
                    <div v-if="user.subscription_status==150">
                        <form @submit.prevent="redirectToWapBilling()"
                              class="gutter-xs q-pa-xs"
                              @keydown="form.onKeydown($event)">

                            <div class="text-center"><img src="../../../img/identity/unitelfutebol-dark.svg"
                                                          width="100%"/></div>
                            <div v-html="suspendMessage"></div>
                            <!-- Submit Button -->
                            <div class="row justify-center">
                                <v-submit :label="$t('log in')"
                                          :loadingLabel="$t('validating...')"
                                          color="primary"
                                          :form="form">
                                </v-submit>
                            </div>

                        </form>

                    </div>
                    <template v-else>

                        {{ $T('you are logged in!') }}
                    </template>
                </div>

            </div>
        </div>
    </q-modal>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "vform";
import axios from "axios";
import {
  QModal,
  QSpinnerPuff,
  QBtn,
  QCheckbox,
  QInput,
  Cookies
} from "quasar-framework";
import VInput from "../../components/form/VInput";

export default {
  name: "VLogin",

  components: {
    VInput,
    QModal,
    QBtn,
    QSpinnerPuff,
    QCheckbox,
    QInput
  },

  data: () => ({
    form: new Form({
      email: "go4@test.com",
      password: "secret",
      remember: false,
      redirectTo: this.slug
    }),
    suspendMessage: ""
  }),

  computed: {
    ...mapGetters({
      user: "auth/user",
      settings: "local/settings"
    }),
    showLogin: {
      get() {
        return this.settings("login");
      },
      set(value) {
        this.$store.dispatch("local/set", { key: "login", value });
      }
    },

    slug: {
      get() {
        return this.settings("redirect-route");
      },
      set(value) {
        this.$store.dispatch("local/set", { key: "redirect-route", value });
      }
    }
  },
  mounted() {
    //this.getSuspendMessage();
  },
  methods: {
    redirectToWapBilling() {
      axios.get(`${config.appUrl}/api/service-url`).then(({ data }) => {
        window.location.href = data;
      });
    },
    getSuspendMessage() {
      axios.get(`${config.appUrl}/api/suspend-message`).then(({ data }) => {
        this.suspendMessage = data;
      });
    },
    async login(slug) {
      let portal = Cookies.get('portal');
      slug = (slug == undefined || slug ==""  )? "desporto" : slug
      this.form.redirectTo = config.appUrlPortal.replace("/", "*").replace("/", "*")+'*'+slug.replace("/", "")
      this.form.portal = portal
      // Submit the form.
      const { data } = await this.form.post(`${config.SkySMSUrl}/login`);
      window.location.href = data;

      // // Save the token.
      // this.$store.dispatch('auth/saveToken', {
      //     token: data.token,
      //     remember: this.form.remember
      // })
      //
      // // Fetch the user.
      // await this.$store.dispatch('auth/fetchUser')
      //
      // // Password expired?
      // // if (this.user.expiredPassword) {
      // //     this.$q.notify({
      // //         color: 'warning',
      // //         icon: 'warning',
      // //         message: this.$T('password expired'),
      // //         detail: this.$T('please, change your password.'),
      // //         position: 'top'
      // //     })
      // //     this.$router.push({name: 'settings.password'})
      // //     return
      // // }
      //
      // // reload da página autal.
      // this.$router.go()
    }
  }
};
// axios.get(`${config.appUrl}/api/sport/subscribe/1`)
//     .then(({data}) => {
//         window.location.href = data;
//
//     })
//     .catch(error => {
//         if (error.response && error.response.status == 404)
//             router.replace('/404')
//     })
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue